import React from 'react';
import { useAuth } from '../../../providers/auth-provider';

function LeaderManagerCoachingTipsIntro() {
  const { clientDisplayName } = useAuth();

  return (
    <div>
      {clientDisplayName} is a strong believer in developing individuals across the organization. As such, you can find
      some proven developmental tips below to help you manage/coach this individual. These action tips are based on the
      assessments that the individual completed as part of the development process. The recommendations included in this
      report are targeted tips that you might find helpful as a manager/coach. Feel free to provide additional context
      and practical advice based on your personal experiences as a leader. These tips are intended to be starters for
      on-going coaching and dialogue.
    </div>
  );
}

export default LeaderManagerCoachingTipsIntro;
